import { GripVertical } from "lucide-react";
import React from "react";

interface DiaryBookingCardDragButtonProps {
  selectedView: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onPointerDown: (e: React.PointerEvent<HTMLButtonElement>) => void;
  onPointerMove: (e: React.PointerEvent<HTMLButtonElement>) => void;
  onPointerUp: (e: React.PointerEvent<HTMLButtonElement>) => void;
  onPointerCancel: (e: React.PointerEvent<HTMLButtonElement>) => void;
  onLostPointerCapture: (e: React.PointerEvent<HTMLButtonElement>) => void;
  onDragStart: (e: React.DragEvent<HTMLButtonElement>) => void;
  onDragEnd: (e: React.DragEvent<HTMLButtonElement>) => void;
}

export const DiaryBookingCardDragButton = React.memo(
  ({
    selectedView,
    onClick,
    onPointerDown,
    onPointerMove,
    onPointerUp,
    onPointerCancel,
    onLostPointerCapture,
    onDragStart,
    onDragEnd
  }: DiaryBookingCardDragButtonProps) => {
    // Only render when in floorplan view
    if (selectedView !== "FloorplanTab") {
      return null;
    }

    return (
      <button
        type="button"
        className="DragIconContainer"
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "36px",
          zIndex: 50,
          pointerEvents: "auto",
          backgroundColor: "transparent",
          border: "none",
          cursor: "grab",
          padding: 0,
          margin: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          touchAction: "none",
          userSelect: "none",
          WebkitUserSelect: "none"
        }}
        onClick={onClick}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerCancel}
        onLostPointerCapture={onLostPointerCapture}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        draggable={true}
        data-drag="true"
        aria-label="Drag booking to floorplan"
      >
        <GripVertical size={28} className="BookingItem-Icon" strokeWidth={2} />
      </button>
    );
  }
);

DiaryBookingCardDragButton.displayName = "DiaryBookingCardDragButton";
